import { url } from "../utils/config";
import axios from "axios";
import Table from "../reusable_components/Table";
import { toast } from "react-toastify";
import { btnGreen, title } from "../utils/style";


function InventoryCheckout() {

    async function checkout(id) {
        try {
            const reqUrl = url + '/inventory_checkout/' + id;
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(reqUrl, { headers }); 
            toast.success(data.message, { autoClose: 3000 })
        } catch (error) {
            toast.error(error.response.data.message, { autoClose: 3000 })
        }
    }
    
    const options = [
        {
            header: 'Location',
            key: 'to',
        },
        {
            header: 'Requested By',
            key: 'requestedBy',
        },
        {
            header: 'Equipment Name',
            key: 'equipmentId',
        },
        {
            header: 'Quantity',
            key: 'quantity',
        },
        {
            header: 'Transfer Note',
            key: 'note'
        },
        {
            header: 'Action',
            render: (data) => {
                return(
                    <>
                        <button className={btnGreen} onClick={() => checkout(data.id)}>Check-Out</button>
                    </>
                )
             },
        }
    ]

    const excludeFilter = ['Transfer Note', 'Action']

    return(
        <div className="p-4">
            <div className={`${title} mb-4`}>Inventory Checkout</div>
            
            <Table 
                options={options} 
                url={url + '/inventory_checkout_list'} 
                pagination 
                noButton
                excludeFilter={excludeFilter}
            />
        </div>
    )
}

export default InventoryCheckout;